import PayoutsPage from "./PayoutsPage";


export default PayoutsPage;